import React from 'react';
import { Link } from 'react-router-dom';
import { Book, Headphones, Settings, HelpCircle, Keyboard, Zap, ChevronRight } from 'lucide-react';
import { documentationSections } from '../../types/docs';

const sectionIcons: { [key: string]: React.ReactNode } = {
  'getting-started': <Book className="w-6 h-6" />,
  'features': <Zap className="w-6 h-6" />,
  'troubleshooting': <HelpCircle className="w-6 h-6" />,
};

const subsectionIcons: { [key: string]: React.ReactNode } = {
  'introduction': <Headphones className="w-5 h-5" />,
  'installation': <Settings className="w-5 h-5" />,
  'keyboard-shortcuts': <Keyboard className="w-5 h-5" />,
  'haptic-feedback': <Zap className="w-5 h-5" />,
};

export const DocsHomePage: React.FC = () => {
  return (
    <div className="max-w-5xl mx-auto px-4 py-8">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold mb-4 text-zinc-200">Documentation</h1>
        <p className="text-zinc-400 max-w-2xl mx-auto">
          Everything you need to know about the Haptic Music Player. From getting started
          to advanced features and troubleshooting.
        </p>
      </div>

      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {documentationSections.map((section) => (
          <div
            key={section.id}
            className="bg-zinc-800/50 backdrop-blur rounded-xl shadow-lg border border-zinc-700/50 overflow-hidden group"
          >
            <div className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="text-yellow-500">
                  {sectionIcons[section.id]}
                </div>
                <h2 className="text-xl font-bold text-zinc-200">{section.title}</h2>
              </div>
              <p className="text-zinc-400 mb-6">
                {section.description}
              </p>
              {section.subsections ? (
                <ul className="space-y-3">
                  {section.subsections.map((subsection) => (
                    <li key={subsection.id}>
                      <Link
                        to={subsection.path}
                        className="flex items-center justify-between p-2 -mx-2 rounded-lg text-zinc-400 hover:text-zinc-200 hover:bg-zinc-700/50 transition-colors group"
                      >
                        <div className="flex items-center gap-3">
                          <span className="text-yellow-500/75 group-hover:text-yellow-500 transition-colors">
                            {subsectionIcons[subsection.id]}
                          </span>
                          <span>{subsection.title}</span>
                        </div>
                        <ChevronRight className="w-4 h-4 text-zinc-600 group-hover:text-zinc-400 transition-colors" />
                      </Link>
                    </li>
                  ))}
                </ul>
              ) : (
                <Link
                  to={section.path}
                  className="inline-flex items-center text-yellow-500 hover:text-yellow-400 transition-colors"
                >
                  Learn more <ChevronRight className="w-4 h-4 ml-1" />
                </Link>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
